import React, {ChangeEvent, useEffect, useState} from 'react';
import {ReactSortable} from "react-sortablejs";
import {ReactComponent as DragIcon} from '../../../../../../../../../../assets/main/groups/online/drag.svg';
import {
    ReactComponent as CorrectIcon
} from '../../../../../../../../../../assets/main/test/response/correct-order/correct.svg';
import {ReactComponent as BasketIcon} from '../../../../../../../../../../assets/main/groups/online/basket.svg';
import {ReactComponent as PlusIcon} from '../../../../../../../../../../assets/main/groups/online/plus.svg';
import {useAppDispatch} from "common/hook";
import {Answer} from "features/model/types/test/getTestIdShema";
import {setAnswerOptions, TestItem} from "features/model/slice/create-test/create-test-form/createTestForm";


interface IFieldsRow {
    values: TestItem;
}

export const FieldsRow = ({values}: IFieldsRow) => {
    const dispatch = useAppDispatch();
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const newId = Math.round(Math.random() * 1000);


    function createEmptyAnswer() {
        return {
            id: newId,
            position: 1,
            text: 'Вариант 1',
            isCorrect: true,
            selected: false,
        };
    }

    function mapAnswer(item: Answer) {
        return {
            id: item.id,
            position: item.position,
            text: item.text,
            isCorrect: item.isCorrect,
            selected: item.selected,
        };
    }


    const initialState: Answer[] = [
        ...(values.answers.length === 0
            ? [createEmptyAnswer()]
            : []),
        ...values.answers.map(mapAnswer),
    ];


    const [state, setState] = useState<Answer[]>(initialState);

    const handleSort = (sortedList: Answer[]) => {
        setState(sortedList);
    };


    useEffect(() => {
        if (values.tabType === 'determineProcedure') {
            const updatedState = state.map((item) => ({
                ...item,
                isCorrect: null,
            }));
            setState(updatedState);
        }
    }, [values.tabType]);


    useEffect(() => {
        const updatedAnswers = state.map(answer => ({
            ...answer
        }));

        const finalUpdatedAnswers = updatedAnswers.map(answer => ({
            ...answer
        }));

        dispatch(setAnswerOptions({testId: values.id, updatedAnswers: finalUpdatedAnswers}));
    }, [state, values.id, dispatch]);



    useEffect(() => {
        const correctAnswer = state.find((item) => item.isCorrect);
        if (correctAnswer) {
            setSelectedId(correctAnswer.id);
        }
    }, [state]);

    const handleDelete = (id: number) => {
        const updatedState = state.filter((item) => item.id !== id);
        setState(updatedState);
    };

    const handleAddAnswer = () => {
        const newAnswer: Answer = {
            id: newId,
            position: state.length + 1,
            text: `Вариант ${state.length + 1}`,
            isCorrect: false,
            selected: false
        };

        const updatedAnswers = [...state,newAnswer];
        setState(updatedAnswers);
    };

    const handleChangeDrag = (event: ChangeEvent<HTMLInputElement>, id: number) => {
        event.stopPropagation(); // Предотвращаем всплытие события
        const updatedState = state.map((item) =>
            item.id === id ? { ...item, text: event.target.value } : item
        );
        setState(updatedState);
    };


    const handleRadioChange = (id: number) => {
        const updatedState = state.map((item) => ({
            ...item,
            isCorrect: item.id === id,
        }));
        setState(updatedState);
        setSelectedId(id);
        dispatch(setAnswerOptions({testId: values.id, updatedAnswers: updatedState}));
    };


    return (
        <>
            <div className="fields-row">
                <div className="field">
                    <div className="radio-group draggable-view">

                        <ReactSortable
                            animation={150}
                            ghostClass="ghost-item"
                            fallbackClass="word"
                            list={state}
                            setList={handleSort}
                        >

                            {state.map((item) => (
                                values.questionType === 'determineProcedure' ? (
                                    <div key={item.id} className="radio-item edit-view has-num">
                                        <input
                                            id={`answer-option-inp${item.id}`}
                                            name="answer-options-5"
                                            type="radio"
                                            checked={item.id === selectedId}
                                        />
                                        <label htmlFor={`answer-option-inp${item.id}`}>
                                            <span className="num">{item.position}.</span>{' '}
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Введите вариант ответа"
                                                value={item.text}
                                                onChange={(event) => handleChangeDrag(event, item.id)}
                                            />
                                        </label>
                                        <span className="drag-icon">
                                            <DragIcon/>
                                        </span>
                                        <span className="delete-icon" onClick={() => handleDelete(item.id)}>
                                            <BasketIcon/>
                                        </span>
                                    </div>
                                ) : (
                                    <div  key={item.id} className="radio-item edit-view">
                                        <input
                                            id={`answer-option-inp${item.id}`}
                                            name={values.id.toString()}
                                            type="radio"
                                            checked={item.id === selectedId}
                                            onChange={() => handleRadioChange(item.id)}
                                        />
                                        <label htmlFor={`answer-option-inp${item.id}`}>
                                            <div className="p-icon">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Введите вариант ответа"
                                                    value={item.text}
                                                    id={`answer-text-inp${item.id}`}
                                                    onChange={(event) => handleChangeDrag(event, item.id)}
                                                />
                                                {item.isCorrect && <span className="icon"><CorrectIcon/></span>}
                                            </div>
                                        </label>
                                        <span className="drag-icon">
                                        <DragIcon/>
                                    </span>
                                        {state.length >= 2 && (
                                            <span className="delete-icon" onClick={() => handleDelete(item.id)}>
                                            <BasketIcon/>
                                        </span>
                                        )}
                                    </div>
                                )
                            ))}
                        </ReactSortable>
                    </div>
                </div>
            </div>
            <p className="p-icon add-test-answer pointer-elem" onClick={handleAddAnswer}>
                Добавить вариант ответа
                <span className="icon">
                    <PlusIcon/>
                </span>
            </p>
        </>
    );
};
